<template>
    <div>
        <div>
            <ReusableDynamicModule :categories="categoriesForModule" :columns="columns" :tableData="tableData"
                :fields="formByCategory.components || []" :pagination="filters" :additional-filters="filters"
                :show-modal="showModal" :form-data="formData" @update-filters="handleFilters"
                @page-change="handlePageChange" @size-change="handleSizeChange" @change-status="changeStatusItem"
                @submit-data="saveData" @edit-item="editItem" @open-modal="openModal" @close-modal="closeModal"
                :title="formByCategory.name" :permissionEdit="permissionEdit" />
        </div>
    </div>
</template>

<script>
import ReusableDynamicModule from "./ReusableDynamicModule.vue";
import { mapActions, mapMutations, mapState } from 'vuex';
import { validarPermisoComponente } from "@/plugins/acl";

export default {
    name: "DynamicIndex",
    components: {
        ReusableDynamicModule,
    },
    props: {
        codeModule: {
            type: String,
            required: true,
        },
        companyId: {
            type: String,
            required: true,
        },
        permissionEdit: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            filters: {
                page: 1,
                per_page: 10,
                total: 0,
                category_id: null,
            },
            columns: [],
            tableData: [],
            fields: [],
            showModal: false,
            formData: {},
            submissionId: null,
            validarPermisoComponente: validarPermisoComponente,
        };
    },
    computed: {
        ...mapState('formBuilder', ['categoriesForModule', 'formByCategory']),
    },
    async mounted() {
        await this.getCategoriesForModule(this.codeModule);
    },
    methods: {
        ...mapActions('formBuilder', ['getCategoriesForModule', 'getFormByCategory', 'saveDataForm', 'getFormSubmissions', 'getFormSubmissionById', 'updateDataForm',
            'changeStatusSubmission'
        ]),

        ...mapMutations('formBuilder', ['setDefaultCategoriesForModule']),

        async loadTableData() {
            this.clearData();
            await this.getFormByCategory(this.filters.category_id);

            if (this.formByCategory.id) {
                const payload = {
                    form_form_id: this.formByCategory.id,
                    company_id: this.companyId,
                    page: this.filters.page,
                    per_page: this.filters.per_page,
                };

                const res = await this.getFormSubmissions(payload);

                if (res) {
                    this.tableData = res.data;
                    this.filters.total = res.total;

                    if (res.data && res.data.length > 0) {
                        this.generateColums(res.data[0].primary_field);
                    }

                }
            }
        },

        async handleFilters({ category_id }) {
            this.filters.category_id = category_id;
            this.loadTableData();
        },

        async handlePageChange(page) {
            this.filters.page = page;
            this.loadTableData();
        },

        async handleSizeChange(size) {
            this.filters.per_page = size;
            this.loadTableData();
        },

        async changeStatusItem(item) {
            const res = await this.changeStatusSubmission({
                form_submission_id: item.id,
                company_id: this.companyId
            });
            if (res) {
                await this.loadTableData();
            }
        },

        async saveData(data) {
            const payload = {
                form_form_id: this.formByCategory.id,
                data,
                company_id: this.companyId,
                submission_id: this.submissionId,
            };

            const action = this.submissionId ? this.updateDataForm : this.saveDataForm;
            const success = await action(payload);

            if (success) {
                await this.loadTableData();
                this.closeModal();
            }
        },

        openModal() {
            this.submissionId = null;
            this.formData = {};
            this.showModal = true;
        },

        closeModal() {
            this.showModal = false;
            this.formData = {};
        },

        async editItem(item) {
            const res = await this.getFormSubmissionById({
                form_submission_id: item.id,
                company_id: this.companyId
            });
            if (res.data) {
                this.submissionId = res.id;
                this.formData = res.data;
                this.showModal = true;
            }
        },

        clearData() {
            this.columns = [];
            this.tableData = [];
            this.filters.page = 1;
            this.filters.total = 0;
            this.filters.per_page = 10;
        },

        generateColums(field) {
            const primaryField = field;
            const newLabel = primaryField && primaryField.label ? primaryField.label : 'Campo Principal';

            this.columns = [
                { key: 'id', label: 'ID' },
                {
                    key: 'primary_field.value',
                    label: newLabel,
                    formatter: (item) => {
                        return item.primary_field ? item.primary_field.value || 'NO REGISTRA' : 'NO REGISTRA';
                    },
                },
                { key: 'created_at', label: 'Fecha de creación' },
                { key: 'is_active', label: 'Estado' },
                this.validarPermisoComponente(this.permissionEdit) ? { key: 'actions', label: 'Acciones' } : null
            ];
        }

    },
};
</script>
